import axios from '../http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块,post数据需要qs格式化
import base from './base'// 导入接口域名列表
//相关接口
;

const myAllWork = {
  //列表数据
  getPage(params) {
    // console.log("----我使用新的了-----"+params)
    return axios.post(`${base.bs}/admin/userwx/tabUserWx/page`, params);
  },
  //根据id查询单个信息
  getById(params) {
    return axios.get(`${base.bs}/admin/userwx/tabUserWx/get/${params.id}`)
  },
  //保存修改
  saveOrUpdate(params) {
    return axios.post(`${base.bs}/admin/userwx/tabUserWx/set`, params)
  },
  //根据id删除单个
  del(params) {
    return axios.get(`${base.bs}/admin/userwx/tabUserWx/del/${params.id}`)
  },
  //批量删除
  batchDel(params) {
    return axios.get(`${base.bs}/admin/userwx/tabUserWx/batchDel?ids=${params.ids}`,null)
  },
  //获取某人附件
  getUpFiles(params) {
    return axios.get(`${base.bs}/admin/userWxUpfiles/getUpFiles/${params.userwxid}/${params.ftype}`,null)
  },

}
// 导出接口
export default myAllWork;



// WEBPACK FOOTER //
// ./src/request/api/tabUserWx.js